export const PASSWORD_SPECIAL = /[!@#$%^&*(),.?":{}|<>]/;
export const PASSWORD_MAX_AGE_DAYS = 90;

export const minPasswordLength = (roleName) =>
  roleName === "Super_Admin" ? 16 : 12;

export const getPasswordChecks = (password = "", username = "", roleName) => {
  const min = minPasswordLength(roleName);
  const value = password || "";
  const user = (username || "").toLowerCase();
  return [
    {
      id: "length",
      label: `At least ${min} characters`,
      ok: value.length >= min,
    },
    { id: "upper", label: "One uppercase letter", ok: /[A-Z]/.test(value) },
    { id: "lower", label: "One lowercase letter", ok: /[a-z]/.test(value) },
    { id: "number", label: "One number", ok: /[0-9]/.test(value) },
    {
      id: "special",
      label: "One special character",
      ok: PASSWORD_SPECIAL.test(value),
    },
    {
      id: "username",
      label: "Does not contain your username",
      ok: !user || !value.toLowerCase().includes(user),
    },
  ];
};

export const passwordIsStrong = (password, username, roleName) =>
  getPasswordChecks(password, username, roleName).every((check) => check.ok);

export const validatePasswordForm = ({
  password,
  repeatPassword,
  username,
  roleName,
}) => {
  const errors = {};
  if (!password) {
    errors.password = "Password is required.";
  } else {
    const failed = getPasswordChecks(password, username, roleName).find(
      (check) => !check.ok
    );
    if (failed) {
      errors.password = `Password must include: ${failed.label.toLowerCase()}.`;
    }
  }
  if (!repeatPassword) {
    errors.repeatPassword = "Please confirm your password.";
  } else if (password !== repeatPassword) {
    errors.repeatPassword = "Passwords do not match.";
  }
  return errors;
};

const asDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const parsePasswordExpiry = (profile = {}) => {
  const users = profile.users || {};
  const expired =
    profile.passwordExpired === true ||
    users.passwordExpired === true ||
    profile.message === "PASSWORD_EXPIRED";

  const expiresAt =
    asDate(
      profile.passwordExpiresAt ||
        profile.passwordExpiryDate ||
        profile.passwordExpireDate ||
        users.passwordExpiresAt ||
        users.passwordExpiryDate
    ) ||
    (() => {
      const lastChanged = asDate(
        profile.passwordChangedAt ||
          profile.lastPasswordChange ||
          profile.passwordUpdatedAt ||
          users.passwordChangedAt ||
          users.lastPasswordChange ||
          users.passwordUpdatedAt
      );
      if (!lastChanged) return null;
      lastChanged.setDate(lastChanged.getDate() + PASSWORD_MAX_AGE_DAYS);
      return lastChanged;
    })();

  const rawDays =
    profile.daysUntilPasswordExpiry ??
    profile.passwordExpiryDays ??
    users.daysUntilPasswordExpiry;
  let daysRemaining =
    rawDays != null && rawDays !== "" ? Number(rawDays) : null;
  if (daysRemaining != null && Number.isNaN(daysRemaining)) {
    daysRemaining = null;
  }
  if (daysRemaining == null && expiresAt) {
    daysRemaining = Math.ceil((expiresAt.getTime() - Date.now()) / 86400000);
  }
  if (expired && (daysRemaining == null || daysRemaining > 0)) {
    daysRemaining = 0;
  }

  return { expired, expiresAt, daysRemaining };
};

export const formatExpiryDate = (value) => {
  const date = asDate(value);
  if (!date) return "";
  return date.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
